module.exports = __webpack_public_path__ + "img/motivosity-logo.a874befc.webp";